import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { changeFormFieldValue } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import NewCardCvvField from 'apps/auth/components/form/NewCardCvvField';
import Form from 'apps/auth/components/form-multi/Form';
import { amplitudeEventForCompletedTopUp } from 'apps/auth/components/utils/AmplitudeUtils';
import { topUpMethods } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { CVV } from 'apps/auth/constants/fieldsName';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { MarkdownService } from 'apps/auth/services/MarkdownService';
import media from 'apps/auth/theme/media';

const FieldMessage = styled.div`
    padding-left: 16px;
    padding-right: 16px;
    margin-top: 12px;

    ${media.tablet720} {
        padding-left: 24px;
        padding-right: 24px;
    }
`;

const TopUpCvvPopup = ({ popupRef = null, ...props }) => {
    const submitRef = useRef(null);

    useEffect(() => {
        if (props.cvv.value && props.cvv.value.length === 3) {
            amplitudeEventForCompletedTopUp(topUpMethods.BANK_CARD);
            submitRef.current.click();
        }
    }, [props.cvv.value]);

    const onSubmitHandler = () => {
        props.changeFormFieldValue(props.formName, '', CVV).then(() => popupRef?.current?.close());
    };

    return (
        <ComplexPopup withoutButton textCenter popupRef={popupRef}>
            <Form
                formName={props.formName}
                getCanonicalPath={true}
                onSubmitHandler={onSubmitHandler}
                submitByEnter={false}
                action={`/auth/ga/pocket/${props.id}/top-up/card/${props.sourceId}/pay.action`}
            >
                <ComplexPopupRow>
                    <p>
                        {MarkdownService.removeNewlines(
                            resolveArguments(props.enterCvvWithParamsTitle, `${props?.card?.alias} ·· ${props?.card?.description}`),
                        )}
                    </p>
                </ComplexPopupRow>
                <fieldset>
                    <NewCardCvvField field={props.cvv} formName={props.formName} focus={true} isNewInput isCenteredInput />
                    <FieldMessage>
                        <Text color="secondary" variant="paragraph" size="secondary" textAlign="center">
                            {props.cvvHint}
                        </Text>
                    </FieldMessage>
                </fieldset>
                <Button type="submit" variant={'hidden'} ref={submitRef} />
            </Form>
        </ComplexPopup>
    );
};

TopUpCvvPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state, ownProps) => {
    return {
        cvv: state.form[ownProps.formName].fields[CVV],
        enterCvvTitle: state.messages.pageMessages.enterCvvTitle,
        enterCvvWithParamsTitle: state.messages.pageMessages.enterCvvWithParamsTitle,
        cvvHint: state.messages.pageMessages.cvvHint,
        id: state.extra.id,
        sourceId: state.extra.sourceId,
        card: state.extra.card,
    };
};

export default connect(mapStateToProps, { changeFormFieldValue })(TopUpCvvPopup);
